import {of} from 'rxjs';
import {switchMap, catchError, map} from 'rxjs/operators';

import {ofType} from 'redux-observable';

import Http from '../../http/http';
import AppSettings from '../../app.settings';

import * as SecurityGroups from './security.action';

const extract = response => response.data;

export const fetch = action$ =>
  action$.pipe(
    ofType(SecurityGroups.SECURITY_GROUPS_RETRIEVAL_INITIATED),
    switchMap(() =>
      Http.get(`${AppSettings.IcebergApiUserInfoEndpoint}/groups`).pipe(
        map(data => SecurityGroups.fetchSuccess(extract(data))),
        catchError(error => of(SecurityGroups.fetchFailure(error)))
      )
    )
  );
